import React from 'react';
import { getThinkingSelectorConfig } from '../../utils/modelThinking';

const ModelSelector = ({
  model,
  models,
  handleModelChange,
  thinkingLevel = '',
  handleThinkingLevelChange = () => {},
  showCustomModelInput,
  customModelName,
  setCustomModelName,
  styles,
  isFlow,
}) => {
  if (isFlow) return null;

  const selectedModelIsLegacy = Boolean(
    model && model !== 'finetuned' && !models.some(item => item.model === model)
  );
  const thinking = getThinkingSelectorConfig(models, model, thinkingLevel);
  const selectStyle = {
    ...styles.apiInput,
    marginTop: '20px',
    marginLeft: 0,
    minWidth: 0,
    flex: '1 1 190px',
    height: '42px',
    borderRadius: '10px',
    fontWeight: 600,
  };

  return (
    <div
      className="model-thinking-controls"
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
        flex: '1 1 420px',
        minWidth: 0,
      }}
    >
      <label htmlFor="chat-model-selector" style={{ position: 'absolute', clip: 'rect(0, 0, 0, 0)' }}>
        AI model
      </label>
      <select
        id="chat-model-selector"
        aria-label="AI model"
        value={model}
        onChange={handleModelChange}
        style={selectStyle}
        className="sleek-select-light"
      >
        {selectedModelIsLegacy && (
          <option value={model}>{model === 'default' ? 'Default model' : `Legacy — ${model}`}</option>
        )}
        {models.map(modelItem => (
          <option key={modelItem.model} value={modelItem.model}>
            {modelItem.model === 'default' ? 'Default model' : modelItem.model}
          </option>
        ))}
        <option value="finetuned">Finetuned Model</option>
      </select>

      <label htmlFor="chat-thinking-level-selector" style={{ position: 'absolute', clip: 'rect(0, 0, 0, 0)' }}>
        Thinking level
      </label>
      <select
        id="chat-thinking-level-selector"
        aria-label="Thinking level"
        value={thinking.value}
        disabled={thinking.disabled}
        onChange={handleThinkingLevelChange}
        style={{ ...selectStyle, opacity: thinking.disabled ? 0.62 : 1 }}
        className="sleek-select-light"
        title={thinking.disabled ? 'The selected model has no configurable thinking level' : 'Select thinking level'}
      >
        {thinking.options.map(option => (
          <option key={`${option.value}:${option.label}`} value={option.value}>{option.label}</option>
        ))}
      </select>

      {showCustomModelInput && (
        <input
          type="text"
          aria-label="Fine-tuned model name"
          placeholder="Enter fine-tuned model name"
          value={customModelName}
          onChange={event => setCustomModelName(event.target.value)}
          style={{ ...styles.apiInput, marginTop: 0, width: '100%' }}
        />
      )}
    </div>
  );
};

export { ModelSelector };
export default ModelSelector;
